import { atom } from "jotai";
import { featurePermissionMapper } from 'permissions';

export const userFeaturesAtom = atom<string[]>([]);

export const userPermissionsAtom = atom((get) => {
  const features = get(userFeaturesAtom);
  const permissions = new Set<string>();

  for (const feature of features) {
    const mapped = featurePermissionMapper[feature] ?? [];
    mapped.forEach((p) => permissions.add(p));
  }

  return Array.from(permissions);
});
